import { TextTestID } from "@/constants/TestID";
import { Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface BoldWeightTextProps {
  shouldAddSpace?: boolean;
  testID: string;
  text: string;
  weight: string;
}

const BoldWeightText = ({
  shouldAddSpace = true,
  testID,
  text,
  weight,
}: BoldWeightTextProps) => {
  const finalText = shouldAddSpace ? ` ${text}` : text;
  return (
    <HStack alignItems="flex-end">
      <Text
        testID={joinTestIDs(testID, TextTestID.BoldText)}
        variant="bodyMedium"
      >
        {weight}
      </Text>
      <Text testID={joinTestIDs(testID, TextTestID.Text)} variant="body">
        {finalText}
      </Text>
    </HStack>
  );
};

export default BoldWeightText;
